import { CustomerProjectStatusModelType } from '@teinor/erp/types/company/customer/customerProjectStatus'
import { useMemo } from 'react'
import SearchBar from '../../../../../../../../baseComponents/SearchBar'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllClientManagerEmployees, getConfigParam, getEmployees } from '../../../../../../../../utils/reducers/getters'
import { CustomSelectWithSearchBar } from '../../../../../../../../forms/CustomSelect'
import { addDictionaryExtraLine } from '../../../../../../../../utils/globals/dictionary'


interface CustomerProjectFlowSubHeaderProps {
    statuses: CustomerProjectStatusModelType[]
    setSearchValue: React.Dispatch<React.SetStateAction<string>>
    setSelectedEmployeeId: React.Dispatch<React.SetStateAction<number | null>>
    searchValue: string
    selectedEmployeId?: number
}

const CustomerProjectFlowSubHeader: React.FC<CustomerProjectFlowSubHeaderProps> = ({ setSearchValue, searchValue, setSelectedEmployeeId, selectedEmployeId }) => {
    const { t } = useTwinTranslation()
    const employees = getEmployees()
    const myEmployees = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getConfigParam('showOnlyClientManagerEmployees') === 'on' ? getAllClientManagerEmployees() || {} : employees || {}))), [employees])
    
    return (
        <div className='flex items-end gap-x-30 flex-wrap gap-y-10'>
            <div className='table_searcher_header'>
                <SearchBar className='search_bar_table' placeholder={t('searchDots', 'Buscar...')} searchValue={searchValue} onChange={(value) => setSearchValue(value)} />
            </div>
            <CustomSelectWithSearchBar sortItems={true} className='w-200 mr-24' label={t('assignedEmployee', 'Empleado asignado')} value={selectedEmployeId} items={myEmployees || {}} fieldName={'fullname_short'} onChange={setSelectedEmployeeId} />
        </div>
    )
}

export default CustomerProjectFlowSubHeader